export default __webpack_public_path__ + "static/media/330C.89426fe9.jpg";